import { DismissIssuePayload, UndismissIssuePayload } from "@/types";
import { API } from "@/utils/api";

/* Get all tasks of current user */
export const getReportById = async (id: string) => {
  const response = await API().get(`/report/${id}`);
  return response.data.data.report;
};

export const dismissIssue = async (payload: DismissIssuePayload) => {
  const response = await API().put(`/report/_dismiss_issue`, payload);
  return response.data.data.issue;
};

export const undismissIssue = async (payload: UndismissIssuePayload) => {
  const response = await API().put(`/report/_undismiss_issue`, payload);
  return response.data;
};
